import React, { useEffect, useContext, useState } from "react";
import { ECLLoader } from "../index";
import { ToastContext } from "../../utilities/contexts";
import ECLBlock from "./ECLBlock";
import sourceOneRestRequest from "../../utilities/requests/SourceOneRestRequest";
import "./ECLBlockument.css";
// import { v4 } from "uuid";

// const idb = getIndexedDB();

export default function ECLBlockument(props) {
   // const blockumentId = useSelectorId(); //This blockument's specific react ID
   const addToast = useContext(ToastContext);
   const [flatDoc, setFlatDoc] = useState(null);
   //NavigateTo takes a blockId (possible an array of blockIDs for lineage?) of a not currently rendered block.  It will hold this block ID
   //and attempt to navigate to it via useEffect each time the flatDoc mutates.  Very backward way of doing this, but since you can't do
   //something like setFlatDoc().then() and have it work, we're left with a suboptimal solution for the moment
   const [navigateTo, setNavigateTo] = useState(null);
   const [revisionCount, setRevisionCount] = useState(0);
   const [error, setError] = useState(null);
   const [title, setTitle] = useState(null);
   //Here we want to start expanding the document.  So call up the document/digital plan/viz
   useEffect(() => {
      //If we don't have a flatDoc above, or if our object is not included in the flat doc, do a request
      if (
         !props.flatDoc ||
         !Object.keys(props.flatDoc).includes(props.object.id + "_root")
      ) {
         // const indexedDBKey = (typeof props.project === "string" ? props.project : props.project.id) + "_" + props.object.id + "_" + props.revision
         //Get all keys to check whether key appears in indexedDB
         // idb.getAllKeys("documents").then(allKeys => {
         //    if (allKeys.includes(indexedDBKey)) {
         //       //If it does, try to get it from IDB
         //       idb.get("documents", indexedDBKey).then(res => {
         //          let mutableDocument = { ...res.document }
         //          // sourceOneRestRequest({
         //          //    query_type: "app_session_get_state_all_blocks",
         //          //    session_key: res.document[props.object.id + "_root"].session
         //          // }).then(sessionState => {
         //          //    console.log("all blocks")
         //          //    console.log(sessionState)
         //          //    //Attach session state to cached document
         //          //    sessionState.data.blocks.forEach(b => {
         //          //       let related = Object.entries(mutableDocument).find(([k,v]) => v.id === b.block_key)
         //          //       if (related?.[0]) {
         //          //          const kvObject = {}
         //          //          b.key_value_pairs.forEach(kv => kvObject[kv.key] = kv.value)
         //          //          mutableDocument[related[0]].state = kvObject
         //          //       }
         //          //    })
         //          // mutableDocument[props.object.id + "_root"].session = v4()
         //          if (props.setFlatDoc) {
         //             //If we have a Flat doc state being passed down to use, add this info to that flat doc state, then
         //             //set our current flatdoc to false so we don't render an embedded document twice
         //             props.setFlatDoc(f => ({ ...f, ...mutableDocument }))
         //             setFlatDoc(false)
         //          } else {
         //             setFlatDoc(mutableDocument)
         //          }
         //          // })
         //       })
         //    } else {
         //The key does not exist in indexedDB, so retrieve the document
         let params = {
            query_type:
               props.object?.meta?.object_type === "report"
                  ? "report"
                  : "digital_plan",
            object: props.object.id,
         };
         sourceOneRestRequest(params)
            .then(async (res) => {
               setTitle(res.title);
               let newDoc;
               if (props.object?.meta?.object_type !== "report") {
                  //If not a report, build a flat Doc and set the relevant FlatDoc state
                  newDoc = buildFlatDoc(
                     res.blocks,
                     props.object.id,
                     res.session_id,
                     true,
                  );
               } else {
                  //Else make a fake document
                  let fauxBlockument = { blocks: [] };
                  fauxBlockument.blocks = Object.keys(res.visualizations).map(
                     (k) => {
                        return { Visualization: res.visualizations[k] };
                     },
                  );
                  //Then create a flat doc as normal
                  newDoc = buildFlatDoc(
                     fauxBlockument.blocks,
                     props.object.id,
                     res.session_id,
                     true,
                  );
               }

               function getChildrenIds(data, blockId) {
                  let childArray = [];
                  let parent = data.find((d) => d.block_id === blockId);
                  if (parent)
                     parent.children_ids.forEach((cid) => {
                        childArray.push(cid);
                        childArray.push(getChildrenIds(data, cid));
                     });
                  return childArray.flat(Infinity);
               }

               //Add in dependents
               Object.values(newDoc).forEach((v) => {
                  const dependents = res.dependency_graph?.find(
                     (x) => x.block_id === v.id,
                  );

                  if (dependents?.children_ids) {
                     v.dependents = getChildrenIds(res.dependency_graph, v.id);
                  }
               });

               if (props.setFlatDoc) {
                  //If we have a Flat doc state being passed down to use, add this info to that flat doc state, then
                  //set our current flatdoc to false so we don't render an embedded document twice
                  props.setFlatDoc((f) => ({ ...f, ...newDoc }));
                  setFlatDoc(false);
               } else {
                  setFlatDoc(newDoc);
               }
               //Find all references to embedded documents
               const embeds = [];
               Object.entries(newDoc).forEach(([k, v]) => {
                  if (k.endsWith("-Document")) {
                     embeds.push(v.document_link);
                  }
                  if (k.endsWith("-Report")) {
                     embeds.push(v.report_link);
                  }
               });
               // //Add this flattened version of the document to indexedDB with its revision ID
               // idb.put("documents", {
               //    compositeId: indexedDBKey,
               //    document: newDoc,
               //    revisionId: typeof props.project === "string" ? props.object.revision : props.project.documents.find(d => d.id === props.object.id).meta.revision,
               //    embeds: embeds
               // })
               // })
               // }
            })
            .catch((error) => {
               //Note that catching the error will both handle the response, as well as any errors within the
               //the logic of the 'then' statements above.
               console.error(error);
               addToast(
                  "There was an error retrieving the document from the server.",
                  "error",
               );
               setError("Document request failed");
            });
      }
   }, []);

   //Build flat doc converts the object provided by the REST query into a flat structure that we can more
   //easily edit
   function buildFlatDoc(blocks, parent, sessionId, generateRoot) {
      //Flat document is an object
      let flatDocument = {};
      //If we passed the generate root option, build a root entry for a document
      const documentKey = parent + "_root";
      if (generateRoot) {
         flatDocument[documentKey] = {
            children: [],
            type: "Document",
            history: [],
            react: {},
            dependents: [],
            session: sessionId,
         };
      }
      //Now iterate over the blocks, adding keys for each step
      blocks.forEach((block, i) => {
         if (block) {
            const blockType = block.type;
            const compositeKey =
               parent + "-" + i + "-" + blockType.replaceAll(" ", "_");

            flatDocument[compositeKey] = {
               children: [],
               id: block.id,
               type: blockType,
               parent: generateRoot ? documentKey : parent,
               history: [],
               react: { refresh: false },
               dependents: [],
               session: sessionId,
            };

            //If we generated a root, be sure that this composite key is added to the root's children
            if (generateRoot) {
               flatDocument[documentKey].children.push(compositeKey);
            }
            //For section block types, copy block.Section data into our new key's data entry.  If collapsible, add a react key for collapsed
            //to toggle sections and their nested contents
            if (blockType === "Section") {
               //Section specific data
               if (block.content.isCollapsible) {
                  flatDocument[compositeKey].react.collapsed = true;
               }
               flatDocument[compositeKey].data = (({ ...o }) => o)(
                  block.content,
               );
               if (Object.keys(block.content).includes("children")) {
                  //Build a flat doc for the object's children
                  const childDoc = buildFlatDoc(
                     block.content.children,
                     compositeKey,
                     sessionId,
                  );
                  //Add these children to the flat document
                  Object.entries(childDoc).forEach(([k, v]) => {
                     flatDocument[k] = v;
                     if (
                        !flatDocument[compositeKey].children.some((key) =>
                           k.startsWith(key),
                        )
                     ) {
                        flatDocument[compositeKey].children.push(k);
                     }
                  });
               }
            }
            //For tab types, create the composite key and set an active tab.  We'll render this tab while ignoring the others
            else if (blockType === "Tabs") {
               //tab specific data
               flatDocument[compositeKey].react.activeTab = 0;
               block.content.tabs.forEach((tab, tabIndex) => {
                  //For each tab child, create a keyed entry, copying the tab's name into the block's data
                  const tabKey = compositeKey + "-" + tabIndex;
                  flatDocument[compositeKey].children.push(tabKey);
                  //tab key (Tabs.tabs.children)
                  flatDocument[tabKey] = {
                     children: [],
                     type: "tab",
                     data: { name: tab.name },
                     parent: compositeKey,
                     history: [],
                     react: {},
                     dependents: [],
                  };
                  //If the tab has children, iterate over them and build their flat docs
                  if (Object.keys(tab).includes("children")) {
                     const childDoc = buildFlatDoc(
                        tab.children,
                        compositeKey + "-" + tabIndex,
                        sessionId,
                     );
                     Object.entries(childDoc).forEach(([k, v]) => {
                        flatDocument[k] = v;
                        if (
                           !flatDocument[tabKey].children.some((key) =>
                              k.startsWith(key),
                           )
                        ) {
                           flatDocument[tabKey].children.push(k);
                        }
                     });
                  }
               });
            }
            //If column, add a column key, then iterate over the column's children
            else if (blockType === "Columns") {
               //Column specific data
               flatDocument[compositeKey].data = (({ ...o }) => o)(
                  block.content,
               );
               if (Object.keys(block.content).includes("children")) {
                  block.content.children.forEach((c, colIndex) => {
                     const colKey = compositeKey + "-" + colIndex;
                     flatDocument[compositeKey].children.push(colKey);
                     //individual Column keys
                     flatDocument[colKey] = {
                        children: [],
                        type: "column",
                        parent: compositeKey,
                        history: [],
                        react: {},
                        dependents: [],
                     };
                     const childDoc = buildFlatDoc(
                        c,
                        compositeKey + "-" + colIndex,
                        sessionId,
                     );

                     Object.entries(childDoc).forEach(([k, v]) => {
                        flatDocument[k] = v;
                        if (
                           !flatDocument[colKey].children.some((key) =>
                              k.startsWith(key),
                           )
                        ) {
                           flatDocument[colKey].children.push(k);
                        }
                     });
                  });
               }
            } else {
               //Any other object will have it's data copied to the flat document's block, and then rendered from there.
               flatDocument[compositeKey].data = {
                  ...block.content,
                  name: block.name,
                  type: block.type ? block.type.replaceAll(" ", "_") : null,
               };
            }
         }
      });
      return flatDocument;
   }
   //handle NavigateTo
   useEffect(() => {
      //If navigateTo is populated and we have a initiated flatDoc, we should handle, otherwise do nothing.
      if (navigateTo && flatDoc !== null) {
         //In this current go round, without having to worry about embedded block linking (yet), we want to find the
         //the block in the our flatdoc so that we can use the flatkey for our html id.
         let flatBlock;
         //don't believe this case exists, but if it's a link embedded in an app that somehow links to a block in the parent app, find
         //the flatkey in props.flatDoc
         if (flatDoc === false) {
            flatBlock = Object.entries(props.flatDoc).find(
               ([, b]) => b.id === navigateTo,
            );
         } else {
            //Otherwise just grab the id from the initiated flatDoc
            flatBlock = Object.entries(flatDoc).find(
               ([, b]) => b.id === navigateTo,
            );
         }
         const linkable = document.querySelector(`#link-${flatBlock[0]}`);
         if (linkable) {
            linkable.scrollIntoView();
            setNavigateTo(null);
         }
      }
   }, [navigateTo, flatDoc]);

   //If flatdoc is unassigned (null), return a loader
   if (flatDoc === null || error) {
      return <ECLLoader message={error} />;
   }
   //If flatdoc is false, we're rendering from props.flatDoc, so the parent Blockument will take care of rendering
   //the children of that flat document
   if (flatDoc === false) {
      return null;
   }
   //Get your blocks and start rendering.  Outline and Blockument are both powered by the same object.  If there's a parent
   //to the blockument, skip rendering the outline (The main blockuments outline will render this.)
   const rootId = props.object.id + "_root";
   const blocks = flatDoc[rootId].children;

   return (
      <article className="blockument">
         <h1>
            {props.project.meta?.project_name}{" "}
            {props.object?.meta?.name
               ? props.object.meta.name
               : props.object.name}
         </h1>
         {title && <h2>{title}</h2>}

         <div className="blockument-display-area">
            {blocks.map((b) => {
               return (
                  <ECLBlock
                     key={b + props.revision}
                     block={flatDoc[b]}
                     project={
                        typeof props.project === "string"
                           ? props.project
                           : props.project.id
                     }
                     flatDoc={props.flatDoc ? props.flatDoc : flatDoc}
                     setFlatDoc={
                        props.setFlatDoc ? props.setFlatDoc : setFlatDoc
                     }
                     flatKey={b}
                     parentDoc={props.parentDoc}
                     headlist={props.headlist ? props.headlist : [rootId]}
                     revisionCount={
                        props.revisionCount
                           ? props.revisionCount
                           : revisionCount
                     }
                     navigateTo={navigateTo}
                     setNavigateTo={setNavigateTo}
                     incrementRevision={
                        props.setRevisionCount
                           ? () => {
                                props.setRevisionCount((n) => n + 1);
                             }
                           : () => {
                                setRevisionCount((n) => n + 1);
                             }
                     }
                  />
               );
            })}
         </div>
      </article>
   );
}
